import CanvasObject from './CanvasObject';
import type SurfaceBase from './SurfaceBase';
import type { LngLat, Point } from './SurfaceBase';

export interface VertexObjectProps {
  point: Point;
  lngLat: LngLat;
}

export default class VertexObject extends CanvasObject {
  point: Point;
  lngLat: LngLat;

  radius: number = 5;
  lineWidth: number = 2;

  // hidden is a "global" way to determine whether the vertex should be rendered
  // "visible" is more used for hiding on drag events and such.
  hidden: boolean = false;

  constructor(id: string, surface: SurfaceBase, options: VertexObjectProps) {
    super(id, surface);
    this.point = options.point;
    this.lngLat = options.lngLat;
    this.sortOrder = 'a0';

    this.on('hoverStart', () => {
      this.lineWidth = 4;
      this.radius = 10;
      this.surface.setCursor('pointer');
      this.renderAll();
    });
    this.on('hoverEnd', () => {
      this.lineWidth = 2;
      this.radius = 5;
      this.surface.resetCursor();
      this.renderAll();
    });
  }

  setCoords = ({ point, lngLat }: VertexObjectProps) => {
    this.point = point;
    this.lngLat = lngLat;
  };

  getLngLatAsArray = () => {
    return [this.lngLat.lng, this.lngLat.lat];
  };

  refreshScreenCoords(): void {
    this.point = this.surface.toScreenCoords(this.lngLat);
    super.refreshScreenCoords();
  }

  refreshMapCoords(): void {
    this.lngLat = this.surface.toMapCoords(this.point);
  }

  render(ctx: CanvasRenderingContext2D) {
    if (this.hidden) return;

    ctx.beginPath();
    ctx.fillStyle = 'white';
    ctx.lineWidth = this.lineWidth;
    ctx.arc(this.point.x, this.point.y, this.radius, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  }

  drawHitArea(ctx: OffscreenCanvasRenderingContext2D | CanvasRenderingContext2D, color: string): void {
    if (this.hidden) return;
    ctx.strokeStyle = color;
    ctx.fillStyle = color;
    ctx.lineWidth = this.lineWidth;
    ctx.beginPath();
    // hit area is twice the radius
    ctx.arc(this.point.x, this.point.y, this.radius * 2, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  }
}
